import styled from 'styled-components';
 
export const FundraisersDetailsSection = styled.section`
     padding-top:60px;         
     padding-bottom:30px;
     position: relative;
     &:after{
        background: #DDF5F6;
        position: absolute;
        width: 100%;
        height: 236px; 
        content: "";
        bottom: 0;
        z-index: -1;
     }
    @media screen and (max-width:1199px){
           padding-top:160px; 
    }
`; 
export const DetailsWrapper = styled.div`
    display: flex;
    gap: 30px;
    @media screen and (max-width:991px){
          flex-wrap: wrap;
    }
`; 
export const DetailsLeft = styled.div`
     width:100%;
     max-width:694px;
    @media screen and (max-width:991px){
       max-width:inherit
    }
`; 
export const DetailsRight = styled.div`
    width:100%;
    max-width: 476px;
 @media screen and (max-width:991px){
       max-width:inherit
    }
`; 
export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 56px;   
@media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
      margin-bottom: 20px;
        margin-top: 30px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
     margin-top: 0;
  }
`; 

export const DetailsImage = styled.div`
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 20px 20px #0000001A;
border-radius: 10px;
padding:10px;
img{
    width:100%;
}   

`; 

export const FundraisersDetailsSlider = styled.div`
    display: flex;
    gap: 30px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
@media screen and (max-width:1199px){
          flex-wrap: wrap;
    }
`; 
export const RangeSliderBox = styled.div`
   background: #33A7AE 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
    width: 100%;
    max-width: 384px;
    padding: 20px 20px 0 20px;
    @media screen and (max-width:1199px){
        max-width:inherit
    }
    .ant-slider-rail{
       background:#fff !important;
    }
    .rage-item {
        h4 {
          color: #fff;
        }
        span{
            color: #fff;
        }
    }
// .ant-tooltip.ant-slider-tooltip {
//         margin-top: -117%;
//         margin-left: 7%;
//     }
`;

export const LocationBox = styled.div`
padding: 20px 20px 20px 0px;
  @media screen and (max-width:1199px){
     width:100%;  
   }
.donate-now-btn{
    padding: 11px 80px;
    margin-top: 18px;
     @media screen and (max-width:1199px){
     width:100%;  
   }
}
`;
export const AddressBox = styled.div`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 0px;
    background: #D3D3D3 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding: 12px 51px 12px 12px;
    display: flex;
    gap: 10px;
    align-items: start;

`;

export const AddressTitle = styled.span`

`;

export const PersonalFundraisersStory = styled.section`
background: #DDF5F6 0% 0% no-repeat padding-box;
padding-bottom:60px;
`;
export const StoryDetails = styled.div`
  display: flex;
  gap:24px;
  align-items: start;
   @media screen and (max-width:991px){
          flex-wrap: wrap;
    }
`;


export const StoryLeft = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #000000;
    border-radius: 15px;
    padding:20px;
    width:100%;
    max-width:894px;
    @media screen and (max-width:991px){
             max-width: inherit;
    }
`;
export const StoryRight  = styled.div`
width:100%;
max-width:282px;
 @media screen and (max-width:991px){
             max-width: inherit;
    }
`;

export const StoryTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 600;
    line-height: 26px;
    margin-bottom: 5px;
`;
export const ContentText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom:20px;

    &:last-child{
       margin-bottom:0px;
    }
`;
export const StoryProfile = styled.div`
    background: #FFFFFF;
    border-radius: 15px;
    padding:20px;
    img{
        width:100%;
    }
`;

export const ProfileName = styled.span`
color: #000000;
font-family: "Jost", sans-serif;
font-size:14px;
font-weight: 500;
line-height: 20px;
margin-bottom: 30px;
margin-top: 15px;
display: block;
`;

export const StoryShare = styled.div`
color: #000000;
font-family: "Jost", sans-serif;
font-size:14px;
font-weight:500;
line-height: 20px;
margin-bottom: 35px;
display: flex;
justify-content: center;
gap: 7px;

 img{
    width:auto;
 }
`;

export const StoryButtonList = styled.ul`
padding: 0;
margin: 0;
list-style: none;
display: flex;
flex-wrap: wrap;
gap:12px;
.social-btn{
        display: flex;
        gap: 10px;
        background: transparent;
        border: none;
        padding: 6px 14px;
        width: 100%;
       justify-content: center;
    }

`;

export const StoryIcon = styled.span`
   img{
    width:auto;
   }
`;
export const StoryButtonItem = styled.li`
    background: #4267B2 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: flex;
    gap:10px;
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 17px;
    margin-bottom: 0px;
    width: calc(50% - 6px);
    padding: 0px;
    justify-content: center;
    align-items: start;
    &:nth-child(2){
        background: #000;
    }
    &:last-child{
        width:100%;
        background:#F7931E;
    }
`;


export const BlueBox = styled.div`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;
    margin-top:20px;
    
    .RatingReview{
        color:#fff;
    }
`;


export const BoxTitle = styled.h3`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 10px;
    text-align:center;
    
`;

export const BoxText = styled.span`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 10px;
    text-align:center;
    display:block;

`;
export const ReadStory = styled.div`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 10px;
    text-align:center;
    display:block;
    text-decoration: underline;
    margin-top: 15px;
    border-top: 1px solid #ffffff66;
    padding-top: 15px;
`;

